import { jsx as _jsx } from "react/jsx-runtime";
import { SolanaSdkFactory, } from '@dialectlabs/blockchain-sdk-solana';
import { DialectContextProvider, DialectWalletStatesHolder, } from '@dialectlabs/react-sdk';
import { PublicKey } from '@solana/web3.js';
import { useCallback, useEffect, useMemo } from 'react';
const SolanaBlockchainSdkWrapper = ({ solanaConfig, ...props }) => {
    const { walletConnected: { set: setWalletConnected }, connectionInitiatedState: { set: setConnectionInitiated }, isSigningFreeTransactionState: { set: setIsSigningFreeTransaction }, isSigningMessageState: { set: setIsSigningMessage }, hardwareWalletForcedState: { get: isHardwareWalletForced }, isEncryptingState: { set: setIsEncrypting }, } = DialectWalletStatesHolder.useContainer();
    const wrapDialectWallet = useCallback((adapter) => {
        return {
            ...adapter,
            signTransaction: adapter.signTransaction
                ? async (tx) => {
                    const isFreeTx = tx.recentBlockhash === PublicKey.default.toString();
                    if (isFreeTx) {
                        setIsSigningFreeTransaction(true);
                    }
                    try {
                        return await adapter.signTransaction(tx);
                    }
                    catch (e) {
                        if (isFreeTx) {
                            // assuming free tx is the tx for auth
                            setConnectionInitiated(false);
                        }
                        throw e;
                    }
                    finally {
                        if (isFreeTx) {
                            setIsSigningFreeTransaction(false);
                        }
                    }
                }
                : undefined,
            signMessage: !isHardwareWalletForced && adapter.signMessage
                ? async (msg) => {
                    setIsSigningMessage(true);
                    try {
                        return await adapter.signMessage(msg);
                    }
                    catch (e) {
                        // assumint sign message used only for auth
                        setConnectionInitiated(false);
                        throw e;
                    }
                    finally {
                        setIsSigningMessage(false);
                    }
                }
                : undefined,
            diffieHellman: adapter.diffieHellman
                ? async (...args) => {
                    setIsEncrypting(true);
                    try {
                        return await adapter.diffieHellman(...args);
                    }
                    finally {
                        setIsEncrypting(false);
                    }
                }
                : undefined,
        };
    }, [
        isHardwareWalletForced,
        setConnectionInitiated,
        setIsEncrypting,
        setIsSigningFreeTransaction,
        setIsSigningMessage,
    ]);
    const blockchainSdkFactory = useMemo(() => {
        if (!solanaConfig.wallet) {
            return null;
        }
        return SolanaSdkFactory.create({
            ...solanaConfig,
            wallet: wrapDialectWallet(solanaConfig.wallet),
        });
    }, [solanaConfig, wrapDialectWallet]);
    useEffect(() => {
        setWalletConnected(Boolean(solanaConfig.wallet));
    }, [solanaConfig, setWalletConnected, blockchainSdkFactory]);
    return (_jsx(DialectContextProvider, { ...props, blockchainSdkFactory: blockchainSdkFactory, children: props.children }));
};
export const DialectSolanaSdk = (props) => {
    return (_jsx(DialectWalletStatesHolder.Provider, { children: _jsx(SolanaBlockchainSdkWrapper, { ...props }) }));
};
//# sourceMappingURL=context.js.map